import { styled, Avatar, Theme, Menu } from '@material-ui/core'

const DROPDOWN_BORDER_RADIUS = 10
const ICON_FONT_SIZE = 20
const USER_NAME_FONT_SIZE = 14
const USER_NAME_MAX_WIDTH = 300

export const Container = styled('div')({})

export const Content = styled('div')({
  display: 'flex',
  width: 'max-content',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
})

export const NameContainer = styled('div')({
  width: 'max-content',
  '& > p': {
    maxWidth: USER_NAME_MAX_WIDTH,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '& .MuiTooltip-popper': {
    '& .MuiTooltip-tooltip': {
      margin: 0,
    },
  },
})

export const Dropdown = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: DROPDOWN_BORDER_RADIUS,
  },
  '& ul': {
    padding: 0,
  },
  '& .MuiListItem-root': {
    padding: theme.spacing(2, 3, 2, 2),
    '&:last-of-type > *': {
      color: theme.palette.error.main,
    },
  },
}))

export const TextContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  '& :first-child': {
    display: 'inline-block',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: USER_NAME_FONT_SIZE,
    '& .MuiSvgIcon-root': {
      fontSize: ICON_FONT_SIZE,
    },
  },
})

export const UserAvatar = styled(Avatar)(
  ({ theme, size }: { theme: Theme; size: number }) => ({
    marginRight: theme.spacing(),
    width: size,
    height: size,
    backgroundColor: theme.palette.success.light,
    color: theme.palette.primary.main,
  })
)
